import { render, staticRenderFns } from "./LcChopApproved.vue?vue&type=template&id=25a5b090&"
import script from "./LcChopApproved.vue?vue&type=script&lang=js&"
export * from "./LcChopApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports